//
//
//
//
//
//
//
//
//

export default {
  props: {
    faq: { type: Object, default: () => ({}) },
  },
}
